import { render, staticRenderFns } from "./detailServices.vue?vue&type=template&id=c68cf214&scoped=true&"
import script from "./detailServices.vue?vue&type=script&lang=js&"
export * from "./detailServices.vue?vue&type=script&lang=js&"
import style0 from "./detailServices.vue?vue&type=style&index=0&id=c68cf214&prod&scoped=true&lang=css&"
import style1 from "./detailServices.vue?vue&type=style&index=1&id=c68cf214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68cf214",
  null
  
)

export default component.exports